import { css } from '@emotion/react';

const setConnectorStyles = {
    containerTitle: css({
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '19px',
        lineHeight: '23px',
        color: '#000000',
        margin: 0,
        marginBottom: 12,
        padding: 0,
    }),
    description: css({
        fontWeight: 400,
        fontSize: '15px',
        lineHeight: '20px',
        color: '#0057B7',
    }),
    content: css({
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '8px',
    }),
    connector: css({
        boxShadow: '0px 3px 11px rgba(0, 0, 0, 0.1)',
        background: '#3CBC00B2',
        display: 'flex',
        color: '#101010',
        alignItems: 'center',
        justifyContent: 'space-between',
        ['&:first-of-type']: {
            borderTopLeftRadius: 6,
            borderTopRightRadius: 6,
            ['& > div:first-of-type']: {
                borderTopLeftRadius: 6,
            },
        },
        ['&:last-of-type']: {
            borderBottomLeftRadius: 6,
            borderBottomRightRadius: 6,
            ['& > div:first-of-type']: {
                borderBottomLeftRadius: 6,
            },
        },
        ['&:not(:last-of-type)']: {
            borderBottom: '2px solid #ffffff',
        },
    }),
    connectorIdThin: css({
        width: '12px',
        minWidth: '12px',
    }),
    connectorShortCode: css({
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '12px',
        lineHeight: '100%',
        color: '#000000',
    }),
    connectorId: css({
        width: '50px',
        height: '100%',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        backgroundColor: '#3CBC00B2',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '40px',
        textAlign: 'center',
        color: '#ffffff',
    }),
    connectorIdBusy: css({
        backgroundColor: '#DAE7FA',
        color: '#000000',
    }),
    connectorInfoContainer: css({
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'space-between',
        flex: 1,
    }),
    connectorInfo: css({
        display: 'flex',
        justifyContent: 'space-between',
        margin: '0 20px 0 0',
    }),
    connectorInfoLabel: css({
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '15px',
        color: '#000000',
    }),
    connectorInfoHead: css({
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '18px',
        lineHeight: '22px',
        color: '#000000',
        marginBottom: '8px',
    }),
    connectorInfoValue: css({
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '12px',
        lineHeight: '15px',
        color: '#000000',
    }),
    connectorIcon: css({
        width: '46px',
        height: '46px',
        color: '#101010',
    }),
    connectorSVG: css({
        background: 'radial-gradient(white 0, white 50%, transparent 60%)',
        color: '#000000',
        fontSize: '46px',
    }),
    connectorTypeName: css({
        color: '#000000',
        fontSize: '12px',
        lineHeight: '12px',
        fontWeight: 500,
    }),
    rightSide: css({
        display: 'flex',
        flexDirection: 'column',
        padding: '15px',
        width: 'calc(100% - 50px)',
        backgroundColor: '#ffffff',
    }),
    rightSideTopBlock: css({
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
    }),
    row: css({
        display: 'flex',
        alignItems: 'center',
        marginBottom: '12px',
        justifyContent: 'space-between',
        marginRight: '20px'
    }),
    unavailable: css({
        backgroundColor: '#8A8A8A4D',
        color: '#000000',
    }),
    goToLocationButton: css({
        display: 'block',
        width: '100%',
        fontSize: 15,
        color: '#004FC6',
        fontWeight: 600,
        padding: 16,
        textAlign: 'center',
        border: 'none',
        backgroundColor: 'transparent',
        boxShadow: 'none',
        marginTop: 40,
        textDecoration: 'none',
    }),
    energyTimeSelectorContainer: css({
        margin: '0 auto',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: '50px',
        outline: 'none',
        overflowY: 'auto',

        '@media (min-width: 600px)': {
            justifyContent: 'center',
            maxWidth: '345px',
        },
    }),
    energyTimeSelectorInnecBlock: css({
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxHeight: '100vh',
        overflowY: 'auto',
        ['&::-webkit-scrollbar']: {
            display: 'none',
        },
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
        paddingBottom: '20px',
    }),
    energyTimeSelectorBlock: css({
        padding: '16px',
        backgroundColor: '#ffffff',
        '@media (min-width: 600px)': {
            borderRadius: '8px',
        },
    }),
    energyTimeSelectorBlockLoader: css({
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }),
    goBackLink: css({
        display: 'flex',
        alignItems: 'center',
        // justifyContent: 'center',
        width: '100%',
        textDecoration: 'none',
        color: '#000000',
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        padding: '20px 16px',

        '@media (min-width: 600px)': {
            padding: '24px 16px',
            marginBottom: '20px',
        },
    }),
    addressBlock: css({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
    }),
    goBackIcon: css({
        marginRight: '12px',
    }),
    locationName: css({
        color: '#000000',
        fontSize: '15px',
        lineHeight: '15px',
        fontWeight: 700,
        marginBottom: '4px',
    }),
    address: css({
        color: '#000000',
        fontSize: '13px',
        lineHeight: '13px',
        fontWeight: 300,
    }),
    cursorStyles: css({
        cursor: 'pointer',
    }),
    connectorStatusContainer: css({
        alignItems: 'center',
    })
};

export default setConnectorStyles;
